import { kuiperClassNames } from '@opallabs/kuiper'
import { MobileSingle, MobileNewsFeed } from './displays'
import { containerStyles } from './styles'
import { FacebookReelParentProps, PostOptionDestination } from './types'

export const FacebookReel: React.FC<FacebookReelParentProps> = ({
  accountImage,
  accountName,
  collabEnabled,
  collabAccount,
  assets,
  content,
  display,
  isPresenting = false,
  location = '',
  postType,
  readOnly = false,
  sound = '',
  truncate,
  scheduledAt,
  timezone,
  onExpandAsset,
  onRemoveAsset,
  updateCoverAsset,
  updateText,
}) => {
  const RenderDisplay =
    display === 'mobileNewsFeed' ? MobileNewsFeed : MobileSingle

  // Used to determine which text field to update for the content
  // type's post options defined in the service builder instructions.
  // See `PostOptionDestination` type for available destination options.
  const onUpdateContentOption = (
    destination: PostOptionDestination,
    value: string
  ) => {
    updateText(value, destination)
  }

  return (
    <div
      css={containerStyles(display, Boolean(assets.length))}
      className={kuiperClassNames(
        `facebook facebook-reel facebook-reel-${display}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        collabEnabled={collabEnabled}
        collabAccount={collabAccount}
        assets={assets}
        content={content}
        contentCharacterLimit={2500}
        contentPlaceholderText="Add content..."
        isPresenting={isPresenting}
        location={location}
        maintainAspectRatio={true}
        postType={postType}
        readOnly={readOnly}
        scheduledAt={scheduledAt}
        sound={sound}
        timezone={timezone}
        truncate={truncate}
        onUpdateContentOption={onUpdateContentOption}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        updateCoverAsset={updateCoverAsset}
      />
    </div>
  )
}
